import {observer} from "mobx-react";
import React from "react";
import {
    ContentFilter, ContentInput, ContentInputAndListableSectorDeleted
} from "./styled";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import {ContentInputSearch} from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/styled";
import Filters from "@dropDesk/presentation/pages/ticket/evaluation/ui/search/search_bar/filters";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";


const SearchBar = observer((
    {
        onSearch,
        setSearchEvaluationValue,
        loading,
        searchEvaluationValue,
        attendant,
        contact,
        setFilterContact,
        setFilterAttendant
    }:
        {
            onSearch: (searchParam?: string) => void,
            setSearchEvaluationValue: (searchEvaluationValue: number | null, withList?: boolean) => void,
            setFilterContact: (contact: UserEntity | null, withList?: boolean) => void,
            setFilterAttendant: (attendant: UserEntity | null, withList?: boolean) => void,
            loading: boolean,
            searchEvaluationValue: number | null
            attendant: UserEntity | null
            contact: UserEntity | null
        }
) => {


    return (
        <ContentFilter>
            <ContentInputAndListableSectorDeleted>
                <ContentInput>
                    <ContentInputSearch>
                        <InputSearchGeneric
                            inputSearchPlaceholder="Pesquise pelo protocolo"
                            loading={loading}
                            onSearch={(value) => onSearch(value)}
                            type={'number'}
                        />
                    </ContentInputSearch>
                </ContentInput>
                <Filters
                    loading={loading}
                    setFilterContact={setFilterContact}
                    setFilterAttendant={setFilterAttendant}
                    setSearchEvaluationValue={setSearchEvaluationValue}
                    contact={contact}
                    attendant={attendant}
                    searchEvaluationValue={searchEvaluationValue}
                    onSearch={onSearch}
                />

            </ContentInputAndListableSectorDeleted>
        </ContentFilter>
    )
})
export default SearchBar;
